<template>
  <div class="componentSty">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="componentSty_content_title">
        <span class="fonints">车牌号码</span>
        <el-input
          placeholder="请输入关键词"
          v-model="conditions.plate"
          clearable
          @blur="queryStatus"
        >
        </el-input>
        <span class="fonints">
          当前状态:
          <span style="color: blue">{{ status }}</span>
        </span>
        <span class="fonints">计划单号:</span>
        <el-input placeholder="请输入关键词" v-model="conditions.pno" clearable>
        </el-input>
        <button class="buttons" @click.stop="queryTableInfo">查询</button>
        <span class="fonints">派车单:</span>
        <el-input placeholder="请输入关键词" v-model="paichedan" clearable>
        </el-input>
        <button
          class="buttons"
          style="background: orange"
          @click.stop="delpaichedan"
        >
          删除派车单
        </button>
      </div>
      <div class="componentSty_content_table" style="border:none">
        <el-table style="width: 100%; " border height="50%" :data="arrlist.data">
           <el-table-column show-overflow-tooltip :render-header="renderHeader"
            label="序号"
            type="index"
            width="50px"
          ></el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="wtbillno" label="计划单号"> </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="bname" label="磅房名称"> </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="storecode" label="仓储编号"> </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="storename" label="仓储名称"> </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="wtype" label="过衡类型"> </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="fleetname" label="代理名称"></el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="truckno" label="车牌号码"></el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="truckrfid" label="司机RFID"></el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader"
            prop="truckdrivername"
            label="司机名称"
          ></el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" label="毛重">
            <template v-slot="res">
              {{ res.row.mquan / 1000 || "" }}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" label="皮重">
            <template v-slot="res">
              {{ res.row.pquan / 1000 || "" }}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" label="净重">
            <template v-slot="res">
              {{ res.row.quan / 1000 || "" }}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" label="净重产生时间">
            <template v-slot="res">
              {{ mydateFormat(res.row.biztime) }}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" label="装货时间">
            <template v-slot="res">
              {{ mydateFormat(res.row.loadtime) }}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" label="入卡口时间">
            <template v-slot="res">
              {{ mydateFormat(res.row.inMouthTime) }}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" label="出卡口时间">
            <template v-slot="res">
              {{ mydateFormat(res.row.outMouthTime) }}
            </template>
          </el-table-column>
        </el-table>
        <div class="paginations" v-show="arrlist.totalCount">
          <el-pagination
            :page-size="conditions.limit"
            layout="total,prev, pager,next, jumper"
            :current-page="conditions.page"
            :total="arrlist.totalCount"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
        <div
          class="componentSty_content_title"
          style="border-bottom: 1px solid #f3f4f5"
        >
          <span class="fonints">计划号</span>
          <el-input placeholder="请输入关键词" v-model="planVal" clearable>
          </el-input>
          <button class="buttons" @click="checkPno">查询</button>
          <button
            class="buttons"
            style="background: orange"
            @click="genxinVersion"
          >
            更新
          </button>
        </div>
        <div class="inForMsgBox" style="width: 50%" v-if="iteminfo">
          <div class="itemBox">
            <span class="key">计划单号:</span>
            <div class="val">{{ iteminfo.pno }}</div>
          </div>
          <div class="itemBox">
            <span class="key">货物名称:</span>
            <div class="val">{{ iteminfo.cARGO_NAME }}</div>
          </div>
          <div class="itemBox">
            <span class="key">场地:</span>
            <div class="val">{{ iteminfo.stname }}</div>
          </div>
          <div class="itemBox">
            <span class="key">货位:</span>
            <div class="val">{{ iteminfo.hwstr }}</div>
          </div>
          <div class="itemBox">
            <span class="key">货主名称:</span>
            <div class="val">{{ iteminfo.cARGO_OWNER_NAME }}</div>
          </div>
          <div class="itemBox">
            <span class="key">计划吨数:</span>
            <div class="val">{{ iteminfo.plantons  || "" }}</div>
          </div>
          <div class="itemBox">
            <span class="key">代理名称:</span>
            <div class="val">{{ iteminfo.cARGO_AGENCY_NAME }}</div>
          </div>
          <div class="itemBox">
            <span class="key">船名:</span>
            <div class="val">{{ iteminfo.shipname }}</div>
          </div>
          <div class="itemBox">
            <span class="key">流向:</span>
            <div class="val">{{ iteminfo.customername }}</div>
          </div>
          <div class="itemBox">
            <span class="key">状态:</span>
            <div class="val">
              <span>
                {{iteminfo.ythStatus}}
              </span>
            </div>
          </div>
          <div class="itemBox">
            <span class="key">代理:</span>
            <div class="val">{{ iteminfo.cARGO_AGENCY_NAME }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import { antiShake } from "@/plugins/other.js";
export default {
  data() {
    return {
      listitem: [{ name: "运维管理" }, { name: "信息管理" }],
      planVal: null,
      conditions: {
        page: 1, //当前页码
        limit: 20, //每页显示条数
        pno: "", //计划单号
        plate: "", //车牌
      },
      iteminfo: "",
      paichedan: "",
      status: "", //车辆状态
      arrlist: {},
    };
  },
  components: {
    mTitle,
  },
  methods: {
    // 查询榜单数据
    async gainTableList() {
      if (!this.conditions.pno) return this.$message.info("请填写计划单号");
      const { data } = await this.$http(
        "api1",
        "/exchangeWeight/list",
        "get",
        this.conditions
      );
      if (data.code != 0) return this.$message.error(data.msg);
      this.arrlist = data.data;
    },
    // 查询车辆状态
    async queryStatus() {
      if (!this.conditions.plate) return "";
      const { data } = await this.$http(
        "api1",
        "/exchangeDispatch/info/" + this.conditions.plate,
        "get"
      );
      if (data.code != 0) return this.$message.error(data.msg);
      this.status = data.data.status;
    },
    delpaichedan() {
      if (!this.paichedan) return "";
      this.$messageBox
        .confirm(`是否删除派车单?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          const { data } = await this.$http(
            "api1",
            "/exchangeDispatch/deleteExchangeDispatch/" + this.paichedan,
            "get"
          );
          if (data.code != 0) return this.$message.error(data.msg);
          this.$message.success("删除派车单成功");
        })
        .catch((err) => err);
    },
    // 查询计划号
    checkPno() {
      if (!this.planVal) return "";
      antiShake(async (_) => {
        const { data } = await this.$http(
          "api1",
          "/jt/api/getPlanInfo?",
          "get", {
		  planNo: this.planVal
		}
        );
		
        if (data.code != 0) return this.$message.error(data.msg);
		console.log('data.data',data.data);
		if(data.data.length>0){
			 this.iteminfo = data.data[0];
		}
       
      });
    },
    // 更新版本
    genxinVersion() {
      if (!this.planVal) return "";
      this.$messageBox
        .confirm(`是否更新?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          const { data } = await this.$http(
            "api1",
            "/fleet/plan/updatePlanStatus/" + this.planVal,
            "get"
          );
          if (data.code != 0) return this.$message.error(data.msg);
          this.$message.success("更新成功");
        })
        .catch((err) => err);
    },
    queryTableInfo() {
      antiShake((_) => {
        this.conditions.page = 1;
        this.gainTableList();
      });
    },
    handleCurrentChange(index) {
      if (this.arrlist.totalCount < this.conditions.limit) return;
      this.conditions.page = index;
      this.gainTableList();
    },
  },
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>